import * as React from "react";
const SvgFiRrBanner5 = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-banner-5_svg__a)">
      <path
        fill="#062147"
        d="M21 13.987s1.637-1.034 2.69-2.008c.51-.471.36-1.311-.272-1.598-.737-.336-2.014-.754-3.419-1.044v-1.41a3.515 3.515 0 0 0-2.824-3.434c-3.27-.653-7.083-.653-10.35 0a3.515 3.515 0 0 0-2.826 3.435v1.409c-1.405.29-2.682.709-3.419 1.044-.63.287-.78 1.128-.272 1.598 1.053.974 2.69 2.008 2.69 2.008S1.134 15.36.1 17.25c-.355.649.292 1.4.991 1.157a35 35 0 0 1 4.317-1.165A1.99 1.99 0 0 0 7 15.285v-.747C8.245 14.28 10.05 14 12 14s3.752.282 5 .539v.746c0 .948.662 1.77 1.592 1.957 1.353.272 3.013.71 4.317 1.165.698.244 1.346-.508.991-1.157C22.864 15.36 21 13.987 21 13.987m-15-1.28v-4.78c0-.713.512-1.333 1.217-1.474A24.7 24.7 0 0 1 12 6c2.078 0 3.748.247 4.784.453A1.51 1.51 0 0 1 18 7.927v4.78C16.67 12.4 14.454 12 12 12s-4.67.4-6 .707"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-banner-5_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrBanner5;
